import { gql } from '@apollo/client';

// QUERIES

export const UserProfileQuery = gql`
    query UserProfile {
        userProfile {
            userId
            email
            firstname
            lastname
            profilePicture72Url
            country
        }
    }
`;

export const UserIdQuery = gql`
    query UserProfile {
        userProfile {
            userId
        }
    }
`;

export const UserFirstnameQuery = gql`
    query UserProfile {
        userProfile {
            firstname
        }
    }
`;

export const UserCreditsQuery = gql`
    query UserCredits {
        userCredits {
            remaining
        }
    }
`;

export const UserSampleSubscriptionQuery = gql`
    query UserSamplesSubscription {
        userSamplesSubscription {
            id
            plan {
                code
            }
        }
    }
`;

export const UserHasSubscriptionQuery = gql`
    query UserHasSubscription {
        userHasSubscription
    }
`;

export const UserAgreementsQuery = gql`
    query UserAgreements {
        userAgreements {
            agreements {
                requireUpdate
                kind
                version
            }
        }
    }
`;

export const AccountBalanceSummaryQuery = gql`
    query AccountBalanceSummary {
        accountBalanceSummary {
            accountingStatus
        }
    }
`;

export const UserAllAccessQuery = gql`
    query UserAllAccess {
        userAllAccess
    }
`;

export const UserAllSubscriptionsQuery = gql`
    query UserAllSubscriptions {
        userAllSubscriptions {
            subscriptions {
                id
                plan {
                    code
                }
            }
        }
    }
`;

// MUTATIONS

export const AcceptUserAgreementsMutation = gql`
    mutation AcceptUserAgreements($agreements: AcceptUserAgreementsInput!) {
        acceptUserAgreements(agreements: $agreements)
    }
`;

// SUBSCRIPTIONS

export const UserCreditsSubscription = gql`
    subscription OnUserCreditsUpdated {
        onUserCreditsUpdated
    }
`;
